import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=5140fd77"
import script from "./FAQ.vue?vue&type=script&lang=ts"
export * from "./FAQ.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports